(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    // Seek only for uploaded (HTML5) videos rendered by Shopify video snippet
    // External (YouTube/Vimeo) are handled via iframe src parameters above.
    function initVideoStart(root) {
      var seconds = parseInt(root.getAttribute('data-video-start-seconds') || '0', 10);
      if (!seconds || seconds < 0) return;

      // Find an HTML5 video inside wrapper (uploaded video case)
      var video = root.querySelector('video');
      if (!video) return;

      // If metadata already loaded, seek immediately; else wait
      var seek = function () {
        try {
          if (!isNaN(video.duration) && video.duration > seconds) {
            video.currentTime = seconds;
          } else {
            // If duration is unknown or shorter, still attempt (browser will clamp)
            video.currentTime = seconds;
          }
        } catch (e) {}
      };

      if (video.readyState >= 1) {
        seek();
      } else {
        video.addEventListener('loadedmetadata', seek, { once: true });
      }
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.video-start-wrapper').forEach(initVideoStart);
    });

    // In case theme re-renders sections via Shopify editor (Theme Editor / dynamic updates)
    document.addEventListener('shopify:section:load', function (event) {
      if (!event || !event.target) return;
      event.target.querySelectorAll('.video-start-wrapper').forEach(initVideoStart);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
